import type { Registration } from "./shared";

/**
 * Seva on the Events page and at Reception: someone paid for a place and
 * will not attend, so the team marks the booking not coming. It stays on
 * the guest list, but out of the headcounts, the Kund tally and the emails
 * for people who are coming. Arriving overrides the mark, so a seva guest
 * who turns up counts again. The backend applies the same rule
 * (backend/src/not-coming.ts).
 *
 * Nothing here reads the chapter config (guestFormat.ts does when it
 * loads), so test fixtures can use it before a test picks its chapter.
 */

/** The team marked the booking not coming. A guest list from a backend
 *  that predates the field has it missing, which reads as not marked. */
export function isMarkedNotComing(
  r: Pick<Registration, "notComingAt">,
): boolean {
  return r.notComingAt != null;
}

/** Marked not coming, and no one on the booking has arrived. */
export function isNotComing(
  r: Pick<Registration, "notComingAt" | "checkedInAt" | "party">,
): boolean {
  return (
    isMarkedNotComing(r) &&
    !r.checkedInAt &&
    !r.party.some((m) => Boolean(m.arrivedAt))
  );
}

/** A place someone paid money for, so marked not coming it is seva. A
 *  gifted or fully discounted place took no payment: it is only not
 *  coming. */
export function isSeva(
  r: Pick<Registration, "bookingType" | "paidAmountCents">,
): boolean {
  return r.bookingType === "paid" && (r.paidAmountCents ?? 0) > 0;
}
